/**
 * Error codes for muted alerts
 *
 * Each map to the filename of svg illustation to show inside alert.
 */
export enum ErrorCode {
  NO_DATA = 'no-data',
  TIMED_OUT = 'timed-out',
  NOT_AUTHORIZED = 'no-permissions',
  GLOBAL_SEARCH = 'muted-gloabl-alert-search',
  GLOBAL_ANSWER = 'muted-gloabl-alert-answer',
  GLOBAL_DATA = 'muted-gloabl-alert-data',
  GLOBAL_IMPORT_SPOTAPPS = 'muted-gloabl-alert-import-spotapps',
  GLOBAL_EXPORT_SPOTAPPS = 'muted-gloabl-alert-export-spotapps',
  GLOBAL_FAVORITE = 'muted-gloabl-alert-favorite',
  GLOBAL_GENERAL_WARNING = 'muted-gloabl-alert-general-warning',
  GLOBAL_PINBOARD = 'muted-gloabl-alert-pinboard',
  GLOBAL_SPOTIQ = 'muted-gloabl-alert-spotiq',
  GLOBAL_TAG = 'muted-gloabl-alert-tag',
  GLOBAL_SUCCESS = 'muted-global-alert-success',
  LOCAL_GENERAL_WARNING = 'muted-local-alert-general-warning',
  LOCAL_GROUP = 'muted-local-alert-group',
  LOCAL_PERMISSION = 'muted-local-alert-permission',
  LOCAL_SPOTIQ = 'muted-local-alert-spotiq',
  LOCAL_SUCCESS = 'muted-local-alert-success',
  LOCAL_TIME_OUT = 'muted-local-alert-time-out',
  LOCAL_VISUALIZATION = 'muted-local-alert-visualization',
  LOCAL_GENERIC_NOT_FOUND = 'muted-local-alert-generic-not-found',
}

// If error code is not provided, show this svg illustration.
// Exclamation mark with some other elements.
export const GLOBAL_MUTED_ALERT_DEFAULT_ILLUSTRATION = ErrorCode.GLOBAL_GENERAL_WARNING;
// Exclamation mark
export const LOCAL_MUTED_ALERT_DEFAULT_ILLUSTRATION = ErrorCode.LOCAL_GENERAL_WARNING;

// Aria label for close button in banner and toast alerts
export const CLOSE_BTN_ARIA_LABEL = 'Close Alert';

/**
 * Delay to hide the toast alert
 *
 * Note: This is tied to animation duration in toast-alert.scss
 * $rd-animation--toast-short (4.8s)
 */
export const TOAST_HIDE_DELAY_MS = 4800;
